import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "react-phone-number-input/style.css";
import "@/core/i18n/config";
import AppRoutes from "./routes.tsx";
import { Provider } from "react-redux";
import { store } from "@/core/store/store";
import { startSessionRefresh } from "@/core/api/sessionRefresh";

startSessionRefresh();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  </StrictMode>,
);
